export function initSlideshow(): void {
    const slides = document.querySelectorAll('.slideshow__slide');
    if (!slides.length) return;

    let slideIndex = 1;

    function showSlides(): void {
        const currentSlide = document.querySelector('.slideshow__slide.active');
        currentSlide?.classList.remove('active');

        slideIndex = (((slideIndex - 1) % slides.length) + slides.length) % slides.length + 1;

        const nextSlide = document.querySelector(
            `.slideshow__slide[data-slide-id="${slideIndex - 1}"]`,
        );
        nextSlide?.classList.add('active');
    }

    function changeSlide(): void {
        slideIndex += 1;
        showSlides();
    }

    showSlides();

    const headerSlideshow = document.getElementById('headerSlideshow');
    const timer = Number(headerSlideshow?.getAttribute('data-timeout') ?? 5000);
    setInterval(changeSlide, timer);
}
